import React from 'react';

export const Spinner: React.FC<{ size?: number }> = ({ size = 16 }) => {
  const dimension = `${size}px`;
  return (
    <span
      className="inline-block animate-spin rounded-full border-2 border-[var(--color-primary-light)] border-t-transparent"
      style={{ width: dimension, height: dimension }}
      aria-hidden="true"
    />
  );
};

export default Spinner;

